export const IMPRINT = 'https://contimo.de/impressum';
export const PRIVACY = 'https://contimo.de/datenschutzerklaerung';
export const CONTACT = 'https://contimo.de/#kontakt';
export const TERMS = 'https://contimo.de/agb';
export const HELP = 'https://contimo.de/support';
